import React, {useState } from "react";
import AttachmentArchivesFilter from "./AttachmentArchivesFilter";
import { getValueFromResource } from "../../../common/timeLiveFunction";
import { useAppDispatch } from "../../../app/hooks";
export const AttachmentArchivesItem = (props: any) => {
    const { t,ModuleArray,IsEdit } = props;
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [selectedModule, setSelectedModule] = useState<{ [object: string]: any }>(ModuleArray[0]);
    const dispatch = useAppDispatch();

    const handleDownloadIcon = (module: any) => {
        setSelectedModule(module);
        openModal();
    }

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-3 gx-1" >
                <thead>
                    <tr className="thHeading align-middle"  >
                        <th className='w-50'>
                            {/* {t('Attachment Name')} */}
                            {getValueFromResource('Attachment Name',dispatch, t)}

                            </th>
                        {IsEdit && 
                        <th className='w-50'>
                            {/* {t('Download Attachments')} */}
                            {getValueFromResource('Download Attachments',dispatch, t)}

                            </th>
                    }
                    </tr>
                </thead>
                <tbody>
                    {ModuleArray.length > 0 && ModuleArray.map((moduleArray: any, i: any) => (
                        <tr key={i}>
                            <td>
                                <span className="d-block">
                                    {moduleArray.label}
                                </span>
                            </td>
                            {IsEdit && 
                            <td>
                                <span className="menu-icon custom-menu cursor-pointer"
                                    onClick={() => handleDownloadIcon(moduleArray)}
                                    data-tooltip-id="tooltip-Description"
                                    // data-tooltip-content={`Download ${moduleArray.label} Attachments`}
                                    data-tooltip-content=
                                    // {t(`Download ${moduleArray.label} Attachments`)}
                                    {getValueFromResource(`Download ${moduleArray.label} Attachments`,dispatch, t)}

                                    data-tooltip-place="bottom"
                                >
                                    <i className="bi bi-download fs-6 ">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>

                            </td>
}
                        </tr>

                    ))}
                </tbody>
            </table >
            {isModalOpen &&
                <AttachmentArchivesFilter t={t} selectedModule={selectedModule} oncloseModal={closeModal} />
            }
        </>
    )
}
